"use client";

import { Skeleton, VStack } from "@chakra-ui/react";

export default function SettingsSkeleton() {
  return (
    <VStack align="start" spaceY={8} width="full">
      {/* Color picker skeleton */}
      <VStack align="start" spaceY={2} width="full">
        <Skeleton height="10" width="52" />
        <Skeleton height="4" width="80" />
      </VStack>

      {/* Each preference item skeleton */}
      {[1, 2, 3, 4].map((i) => (
        <VStack key={i} align="start" spaceY={2} width="full">
          <Skeleton height="6" width="48" />
          <Skeleton height="4" width="80" />
        </VStack>
      ))}
    </VStack>
  );
}
